import localVars from '../constants/localVariables';

export default function getEnvVar(key) {
  if (process.env.NODE_ENV === 'development') {
    return localVars[key];
  } else {
    // eslint-disable-next-line no-undef
    return config[key];
  }
}
